import auth from "./auth";
import AuthService from '../services/AuthService';

export default {
    template: '#vs-header-template',
    data () {
        return {
            user: null
        }
    },
    ready(){

    },
    events: {
        'user-logged-in': function (user) {
            this.user = user;
        },
        'user-logged-out': function () {
            this.user = null;
        }
    },
    methods: {
        openLogin(){
            this.$broadcast('open-login');
        },
        openRegister(){
            this.$broadcast('open-register');
        },
        logout(){
            this.getAuthService().logout(
                ()=> {
                    this.$dispatch('on-user-logout');
                },
                ()=> {

                }
            )
        },
        getAuthService(){
            return new AuthService(this.$root.service.request.object);
        }
    },
    computed: {
        gravatarLink(){
            if (this.user) {
                return `https://www.gravatar.com/avatar/${md5(this.user.email)}`;
            }
        },
        loggedIn(){
            return this.user != null;
        }
    },
    components: {
        'auth': auth
    }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/vsHeader.js